import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';
import type { ColorRowValues } from '../model/color-form';

interface ColorSwatchStripProps {
  readonly rows: readonly ColorRowValues[];
  /** RHF fieldArray 가 발급한 행 key — 스와치와 행의 identity 를 맞춘다. */
  readonly fieldIds: readonly string[];
}

/** 색상 옵션의 스와치 미리보기 스트립 — 수급 불가 색상은 흐리게·취소선으로 표시한다. */
export const ColorSwatchStrip = ({ rows, fieldIds }: ColorSwatchStripProps): ReactElement => (
  <ul className="flex flex-wrap gap-4" aria-label="색상 스와치 미리보기">
    {rows.map((row, index) => (
      <li key={fieldIds[index] ?? index} className="flex w-14 flex-col items-center gap-1">
        <span
          className={cn(
            'size-8 rounded-full border shadow-inner',
            !row.isAvailable && 'opacity-30',
          )}
          style={{ backgroundColor: row.colorCode }}
          title={row.name}
          aria-hidden="true"
        />
        <span
          className={cn(
            'max-w-full truncate text-[11px]',
            row.isAvailable ? 'text-muted-foreground' : 'text-destructive line-through',
          )}
        >
          {row.name || '(이름 없음)'}
        </span>
      </li>
    ))}
  </ul>
);
